<template>
  <div>
  <swiper v-bind:options="swiperOption">
    <swiper-slide v-for="(item, index) in courseRecord" v-bind:key="index">
      <div class="statistics-item">
      <div class="statistics-item-content">
        <div class="statistics-item-name">{{item.cate_name}}</div>
        <div class="statistics-item-circle">
          <i-circle :percent="item.ratio" stroke-color="#ff9e67">
            <span>{{item.ratio}}%</span>
          </i-circle>
        </div>
        <div class="statistics-item-progress">
          学习进度<span style="color: rgb(39, 164, 255);">{{item.count}}</span>/{{item.total}}
        </div>
      </div>
      </div>
    </swiper-slide>
    <div class="swiper-button-next" slot="button-next"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
  </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import apiUrl from "../../api/api.url.js"
export default {
  data () {
    return {
      swiperOption: {
         loop: true,
         speed: 1000,
         autoplay:true,
         observer: true,
         observeParents: true,
         autoplayStopOnLast: false,
         navigation: {
           nextEl: ".swiper-button-next",
           prevEl: ".swiper-button-prev",
         },
      },
      teadefimg: require('@/assets/images/teacher-default.png'),
      imageUrl: apiUrl.imageURL
    };
  },
  props: {
    courseRecord: {
      type: Array,
      default: () => []
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
  },
  methods:{
  }
};
</script>

<style lang="less" scoped>
  .statistics-item {
    width: 350px;
    margin-bottom: 20px;
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(../../assets/study-statistics-bg.png) no-repeat 50%
  }

  .statistics-item .statistics-item-content {
    flex: 1
  }

  .statistics-item .statistics-item-content .statistics-item-name {
    font-size: 20px;
    color: #666;
    text-align: center;
  }

  .statistics-item .statistics-item-content .statistics-item-progress {
    margin-top: 10px;
    color: #666;
    font-size: 20px;
    text-align: center
  }

  .statistics-item .statistics-item-content .statistics-item-progress .progress-item {
    width: 146px;
    display: inline-block
  }

  .statistics-item .statistics-item-content .statistics-item-progress .progress-item+.progress-item {
    border-left: 1px solid #c4c4c4
  }

  .statistics-item .statistics-item-content .statistics-item-progress .progress-item p:first-child {
    font-size: 16px
  }

  .statistics-item .statistics-item-content .statistics-item-progress .progress-item p:first-child span {
    font-size: 30px;
    color: #333
  }

  .statistics-item .statistics-item-content .statistics-item-circle {
    width: 100%;
    padding: 40px 0 0 0;
    text-align: center
  }

  .statistics-item .statistics-item-content .statistics-item-circle span {
    font-size: 20px;
    color: #666
  }
.teacher-info {
  text-align: center;
}
.swiper-button-next,
.swiper-button-prev {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 2px;
  background-color: #fff;
  text-align: center;
  outline: none;
  padding-top: 1px;
  &::after {
    font-size: 12px;
    color: #999;
  }
}
.swiper-button-prev {
  top: 30px;
  left: 282px;
}
.swiper-button-next {
  top: 30px;
  right: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/mall/TeacherSlider.vue